import React from "react";

export const ImageQuestionAnswerRadio = (props) => {
    return (
        <>
            <div className="sb-quest-answers__radio">
                <input id={props.id} name={props.name} type="radio" />
                <label htmlFor={props.for} className="radio-label">
                    {props.label}
                    {props.image && 
                   <img src={props.image} />}
                </label>
            </div>
        </>
    )
}


export const ImageQuestionAnswerMultiple = (props) => {
    return (
        <>
            <div className="sb-quest-answers__radio">
                <input id={props.id} name={props.name} type="checkbox" />
                <label htmlFor={props.for} className="radio-label">
                    {props.label}
                   <img src={props.image} />
                </label>
            </div>
        </>
    )
}